<template>
  <ReferenceLayout>
    <template #heading>
      <h3 class="text-left q-mx-md text-primary">
        {{ $t("ETAB.REFERENCE.@TITLE") }}
      </h3>
      <ExtraLargeTipbox class="q-mb-xl">
        <p class="text-bold text-left">
          {{ $t("ETAB.REFERENCE.@TIP_BOX_TITLE") }}
        </p>
        <p class="text-left">
          {{ $t("ETAB.REFERENCE.@TIP_BOX_EXTRACADABRA_DESCRIPTION") }}
        </p>
      </ExtraLargeTipbox>
    </template>
    <template #content>
      <VeeForm ref="form" class="frontpage-candidate-reference-prospect-form" @submit="save">
        <div class="row q-mb-lg">
          <div class="col-12 col-md-6 q-px-lg q-mb-lg">
            <QCard class="bg-grey-2">
              <QCardSection>
                <div class="text-center q-gutter-md">
                  <Avatar :picture="candidateInformations.getPicture()" size="100px" />
                  <p class="text-bold">
                    {{ candidateInformations.getFullName() }}
                  </p>
                  <p>{{ $t("ETAB.REFERENCE.@CANDIDATE_AGE", { years: candidateInformations.getAge() }) }}</p>
                  <p class="text-left text-body2">
                    {{ $t("ETAB.REFERENCE.@ASKING_REFERENCE", { identity: candidateInformations.getFirstname() }) }}
                  </p>
                  <QCard v-if="candidateInformations.getContract()" class="frontpage-reference-experience-description" bordered flat>
                    <QCardSection>
                      <p class="text-bold">
                        {{ candidateInformations.getQualification().getLabel() }}
                      </p>
                      <p>
                        {{
                          $t("ETAB.REFERENCE.@ETAB_NAME_AND_LOCATION", {
                            etablissement: candidateInformations.getEtabName(),
                            postalCode: candidateInformations.getPostalCode(),
                          })
                        }}
                      </p>
                      <p class="q-mb-none">
                        {{ displayJobsDuration }}
                      </p>
                    </QCardSection>
                  </QCard>
                </div>

                <!-- rating fieldset -->
                <CandidateReferenceRatingFieldset :candidate-informations="candidateInformations" :candidate-prospect="candidateProspect" />
              </QCardSection>
            </QCard>
          </div>
          <div class="col-12 col-md-6 q-px-lg">
            <!-- prospect fieldset -->
            <CandidateReferenceProspectFieldset :candidate-informations="candidateInformations" :candidate-prospect="candidateProspect" />
          </div>
        </div>
        <div class="text-center q-mt-md">
          <QBtn no-caps class="btn-large" color="secondary" type="submit" :label="$t('ETAB.REFERENCE.LABELS.@SEND_REFERENCE')" />
        </div>
      </VeeForm>
    </template>
  </ReferenceLayout>
</template>

<script>
  import { EncodingHelpers } from "@core/helpers/encoding.helpers";
  import { CandidateReferenceModel, CandidateReferenceProspectModel, ICandidateReferenceProspect } from "@core/models/candidates/reference";
  import { CandidateReferenceService } from "@core/services/candidates/candidate-reference.service";
  import { NotificationsManager } from "@core/managers/notifications.manager";
  import { WWW_ETAB_URL } from "@core/constants";

  import { JavascriptHelpers } from "@core/helpers";
  import ReferenceLayout from "@etab/layouts/Reference.layout.vue";
  import CandidateReferenceProspectFieldset from "@etab/components/reference/candidate-reference-prospect.fieldset.vue";
  import CandidateReferenceRatingFieldset from "@etab/components/reference/candidate-reference-rating.fieldset.vue";
  import { Form as VeeForm } from "vee-validate";
  export default {
    components: {
      CandidateReferenceRatingFieldset,
      CandidateReferenceProspectFieldset,
      ReferenceLayout,
      VeeForm,
    },
    data() {
      return {
        candidateProspect: new CandidateReferenceProspectModel(),
        candidateInformations: new CandidateReferenceModel(),
      };
    },
    computed: {
      token() {
        return this.$route.query.token;
      },

      displayJobsDuration() {
        const contract = this.$t(this.candidateInformations.getDisplayedContract());
        if (this.candidateInformations.getEndDateDisplay()) {
          return this.$t("ETAB.REFERENCE.@JOBS_CONTRACT_AND_DURATION", {
            contract,
            start: this.candidateInformations.getStartDateDisplay(),
            end: this.candidateInformations.getEndDateDisplay(),
          });
        }
        return this.$t("ETAB.REFERENCE.@ACTUAL_JOBS_CONTRACT_AND_DURATION", {
          contract,
          start: this.candidateInformations.getStartDateDisplay(),
        });
      },
    },
    created() {
      this.getCandidateInformations();
      this.ICandidateReferenceProspect = ICandidateReferenceProspect;
      // we have to set rating as a number (here 5) to avoid QRating error
      this.candidateProspect[ICandidateReferenceProspect.rating] = 5;
    },
    methods: {
      async save() {
        try {
          this.$_startGlobalLoading();
          await CandidateReferenceService.sendReference({ prospect: this.candidateProspect, token: this.token });
          NotificationsManager.success({ message: "SUCCESS.@CANDIDATE_REFERENCE_SENT" });
          this.backToHome();
        } catch (error) {
          switch (error.response?.status) {
            case 403:
              NotificationsManager.info({
                message: this.$t("INFO.@CANDIDATE_REFERENCE_ALREAY_SENT", { name: this.candidateInformations.getFullName() }),
              });
              break;
            default:
              NotificationsManager.error();

              break;
          }
          throw error;
        } finally {
          this.$_stopGlobalLoading();
        }
      },
      backToHome() {
        return JavascriptHelpers.openUrl(WWW_ETAB_URL, "_self");
      },
      getCandidateInformations() {
        try {
          const decodedToken = EncodingHelpers.getDecodedJWTToken(this.token);
          this.candidateInformations = new CandidateReferenceModel(decodedToken);
        } catch (error) {
          NotificationsManager.error();
          this.backToHome();
        }
      },
    },
  };
</script>

<style lang="scss">
  .frontpage-candidate-reference-prospect-form {
    .extra-avatar {
      margin-top: -40px;
    }
  }
</style>
